<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <!-- <v-toolbar-title style="font-size:1rem;">设备信息</v-toolbar-title> -->
      <v-toolbar-title style="font-size:1rem;width:90%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">设备信息 - {{companyInfo.COMPANY_NAME}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item @click="goCreateOrder" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-plus-square" />
              <span>新建报障单</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0;">
        <div v-if="loading" style="margin-top:10rem;"><LoadingText /></div>
        <div v-else>
          <div><DeviceStateCard :dev-info="devInfo" /></div>
          <div v-if="devErrorInfo.length > 0">
            <DeviceErrorMessage :iot-id="iotId" :error-info="devErrorInfo" :server-time="errServerTime" />
          </div>
          <div style="padding:0.9rem 1.1rem 5rem;">
            <div style="position:relative;">
              <div style="position:absolute;left:-0.25rem;top:0;width:4.5rem;height:4.5rem;">
                <DeviceIconImage :dev-info="devInfo" :size="72"  />
              </div>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0;">
                  <!-- 当前状态 -->
                </v-col>
                <v-col :cols="9" style="padding-bottom:0.6rem;">
                  <DeviceStateText :dev-info="devInfo" />
                  <DeviceStateIcon v-if="!devInfo.offLine && devInfo.ACTION_TIME" :normal="normal" />
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  <!-- 设备名称 -->
                </v-col>
                <v-col :cols="9" style="padding-top:0px;padding-bottom: 0px;">
                  {{devInfo.DEV_TEXT}}
                </v-col>
              </v-row>
              <v-row v-if="systemTag">
                <v-col :cols="3" style="color:#9e9e9e;padding:0">
                  <!-- 系统标签 -->
                </v-col>
                <v-col :cols="9" style="padding:0px;">
                  <v-chip class="ma-2" label small outlined style="color:#9E9E9E">
                    {{systemTag}}
                  </v-chip>
                </v-col>
              </v-row>

            </div>

            <div v-if="showMoreProp">
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">接口类型</v-col>
                <v-col :cols="9" style="word-break:break-all;">{{propInfo.pr_interface_type}}</v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">端口</v-col>
                <v-col :cols="9" >{{propInfo.pr_host_port}}</v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  检查间隔
                </v-col>
                <v-col :cols="9">
                  {{propInfo.pr_span_time_s}} 秒
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  活跃时间
                </v-col>
                <v-col :cols="9" v-if="activated">
                  <!-- {{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}} -->
                  <span style="padding-right:0.3rem;" v-if="devInfoFormatTime">( {{devInfoFormatTime}} )</span>
                  <span>{{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  主机名称
                </v-col>
                <v-col :cols="9">
                  {{devInfo.GW_DEV_TEXT}}
                </v-col>
              </v-row>
            </div>

            <div style="color:#9e9e9e;font-size:0.8rem;text-align:center;margin-top:0.5rem;">
              <span @click="showMoreProp=!showMoreProp">
                <span>查看更多</span>
                <i class="fa fa-angle-down" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-if="!showMoreProp"></i>
                <i class="fa fa-angle-up" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-else></i>
              </span>
            </div>
            <v-divider style="margin:1rem 0;" />

            <div v-if="!offLine">

              <div v-if="templateLoading && templateIsNotNull">
                <div v-for="(item,index) in templateLabel" :key="'label' + index" style="font-size:14px;">
                  <v-row v-if="item.visible">
                    <v-col :cols="3" style="color:#9e9e9e;padding-right:0;padding-top: 28px;">
                      <span>{{item.value_text}}</span>
                    </v-col>
                    <v-col :cols="9">
                      <div style="display: inline-block" v-html="item.show_text" />
                    </v-col>
                  </v-row>
                </div>

                <div v-for="(item,index) in templateProgress" :key="'progress' + index" style="font-size:14px;">
                  <v-row v-if="item.visible">
                    <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                      {{item.value_text}}
                    </v-col>
                    <v-col :cols="9">
                      <v-progress-linear
                        v-model="item.value"
                        height="20"
                        :color="percentColor(item.value)"
                        striped
                        style="width:90%;border-radius:2px;pointer-events:none;">
                        <div style="padding-top:0.1rem;font-size:0.8rem;">{{ item.value }} %</div>
                      </v-progress-linear>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="templateChart && templateChart.length > 0" style="margin-top:20px;">
                  <div v-for="(item,index) in templateChart" :key="'charts' + index" >
                    <v-row v-if="item.visible">
                      <v-col :cols="12">
                        <StatTemplateCommonChart
                          v-if="echartLoad"
                          :id="'chart' + index"
                          height="240px"
                          :range="item.chart_params.range"
                          :title="item.chart_params.title"
                          :data="item.value"
                          :tag-name="item.charts"
                          :unit="item.chart_params.unit_name"
                          :time-interval="item.chart_params.time_interval"
                          :date-format="item.chart_params.format"
                          :series-type="item.chart_params.series_type"
                          :chart-type="item.chart_params.type"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </div>
               </div>
              <div
                v-else
                style="text-align: center;
                color: #909399;
                font-size:0.8rem;
                height: 100px;
                line-height: 100px;">
                {{ templateIsNotNull ? '正在努力加载中...' : '暂无模板数据'}}
              </div>
            </div>
            <v-divider style="margin:1rem 0;" />
            <div>
              <div style="padding-bottom:0.3rem;color:#9e9e9e;">
                <v-icon color="warning" style="font-size:1.05rem;margin-right:0.3rem;">fa-volume-down</v-icon>告警记录
              </div>
              <AlertHistory :iot-id="iotId" />
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import DeviceStateText from './components/DeviceStateText'
import DeviceIconImage from './components/DeviceIconImage'
import DeviceStateCard from './components/DeviceStateCard'
import AlertHistory from './components/AlertHistory'
import DeviceErrorMessage from './components/DeviceErrorMessage'
import DeviceStateIcon from './components/DeviceStateIcon'
import StatTemplateCommonChart from './components/StatTemplateCommonChart'
export default {
  components: {
    LoadingText,
    DeviceStateText,
    DeviceIconImage,
    DeviceStateCard,
    AlertHistory,
    DeviceErrorMessage,
    DeviceStateIcon,
    StatTemplateCommonChart
  },
  props: {},
  data() {
    return {
      iotId: '',
      propInfo: {},
      devInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: true,
      loading: true,
      onlineHistVis: false,
      normal: false,
      offLine: false,
      devErrorInfo: [],
      systemTag: '',
      tagPrefix: 'yqyw@',
      devInfoFormatTime: '',
      errServerTime: '',
      range: 10,
      echartLoad: false,
      templateArray: [],
      templateLabel: [],
      templateProgress: [],
      templateProgressArray: [],
      templateChart: [],
      templateIsNotNull: true,
      templateLoading: false
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.iotId = that.$route.query.iot_id
    await that.getDevice()
    await that.getDevProp()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 获取设备信息
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.warning('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.devInfoFormatTime = that.getDevInfoFormatTime(data.device.ACTION_TIME, res.time)
        that.devInfo = data.device
        that.companyInfo = data.company
        that.activated = that.devInfo.CUR_SID !== '0' && that.devInfo.CUR_SID !== 0
        that.normal = data.normal
        that.getDeviceSystemTags(that.devInfo.DEV_TAGS)
        // 离线退出
        if (data.device.offLine) {
          that.devErrorInfo = []
          that.offLine = true
          return
        }
        that.offLine = false
        that.getDeviceErrorMessage()
        that.getDeviceTemplate()
      })
    },
    // 获取设备属性
    async getDevProp() {
      var that = this
      var res = await that.$api.iot.getDeviceProp({ iot_id: that.iotId })
      // console.log('getDeviceProp.res', res);
      if (!res.success) {
        // that.$toast.warning('获取设备属性失败')
        console.log('获取设备属性失败', res);
        return
      }
      that.propInfo = res.data
    },
    // 获取设备错误信息
    async getDeviceErrorMessage() {
      var that = this
      var res = await that.$api.iot.getDeviceErrorInfo({ iot_id: that.iotId })
      // console.log(res)
      if (!res.success) {
        console.log('获取设备错误信息失败', res)
        return
      }
      that.errServerTime = res.time
      that.devErrorInfo = that.judgeObjectIsNull(res.data) ? [] : res.data.items
    },
    // 跳转页面-设备状态历史
    goStateHistory() {
      var that = this
      that.$router.goPage({ path: '/DeviceStateHistory', query: { iot_id: that.iotId }})
    },
    // 判断对象是否为空
    judgeObjectIsNull(v) {
      if (!v) {
        return true
      }
      if (!v.items) {
        return true
      }
      return (JSON.stringify(v) === '{}' || JSON.stringify(v.items) === '{}')
    },
    // 跳转页面-创建报障工单
    goCreateOrder() {
      var that = this
      that.$router.goPage({
        path: '/CreateOrder',
        query:
        {
          title: '[' + that.devInfo.DEV_TEXT + ']异常',
          content: that.$Common.jointContent(that.devErrorInfo)
        }
      })
    },
    getDeviceSystemTags(tags) {
      if (tags === '' || !tags) {
        return []
      }
      var that = this
      var taglist = tags.split(';')
      for (let i = 0; i < taglist.length; i++) {
        if (taglist[i].startsWith(that.tagPrefix)) {
          that.systemTag = taglist[i].replace(that.tagPrefix, '')
          break
        }
      }
      return
    },
    getDevInfoFormatTime(dataTime, nowTime) {
      var that = this
      if (dataTime && nowTime) {
        return that.$moment(dataTime).from(nowTime)
      } else if (dataTime) {
        return that.$moment(dataTime).from()
      } else {
        return ''
      }
    },
    async getDeviceTemplate() {
      var that = this
      var res = await that.$api.iot.getIotOssByName({ iot_id: that.iotId, name: 'ui_template.config.json', role: 1 })
      // console.log('getDeviceTemplate.res', res)
      if (!res.success) {
        // that.$eleUtil.warningMsg(res.error_msg)
        console.log('获取设备模板数据失败', res)
        if (!that.templateLoading) {
          that.templateIsNotNull = false
          that.templateLoading = true
        }
        return
      }
      var data = that.strToJson(res.data)
      // console.log(data)
      if (data && data.items && data.items.length > 0) {
        var items = data.items
        var label = []
        var progress = []
        var charts = []

        for (let i = 0; i < items.length; i++) {
          const element = items[i]
          // console.log(element)
          if (element.visible) {
            // element.range = 'today/yesterday'
            if (element.name === 'sys_label') {
              var arr = that.rangeArray(element.sub_name)
              element.show_text = ''
              var unit = element.unit_name
              var byte_params = element.byte_params
              if (!byte_params) {
                byte_params = {}
              }
              if (arr && arr.length > 0) {
                for (let j = 0; j < arr.length; j++) {
                  const sub_name = arr[j]
                  var arr_val = await that.getTemplateByFiled(element.fields, sub_name)
                  if (element.byte_rule || byte_params.byte_rule) {
                    // arr_val = that.byteFormat(element.unit_name, arr_val)
                    if (element.byte_fit || byte_params.byte_fit) {
                      var d = that.$util.formatByteText(arr_val, 2)
                      var arrd = d.split(' ')
                      arr_val = arrd[0]
                      unit = arrd[1]
                    } else {
                      arr_val = that.byteFormat(element.unit_name, arr_val)
                    }
                  }
                  var date_type = '今天'
                  if (sub_name === 'yesterday') {
                    // element.show_text += `昨天 ( ${that.$util.thousandSeparator(arr_val)} ${unit} )\n`
                    date_type = '昨天'
                  } else if (sub_name === 'today') {
                    // element.show_text += `今天 ( ${that.$util.thousandSeparator(arr_val)} ${unit} )\n`
                    date_type = '今天'
                  }
                  element.show_text += that.jointHtml(date_type, sub_name, arr_val, unit)
                }
              } else {
                var val = await that.getTemplateByFiled(element.fields)
                if (element.byte_rule || byte_params.byte_rule) {
                  // val = that.byteFormat(element.unit_name, val)
                  if (element.byte_fit || byte_params.byte_fit) {
                    var dt = that.$util.formatByteText(val, 2)
                    var arrdt = dt.split(' ')
                    val = arrdt[0]
                    unit = arrdt[1]
                  } else {
                    val = that.byteFormat(element.unit_name, val)
                  }
                }
                // element.show_text = `今天 ( ${that.$util.thousandSeparator(val)} ${unit} )\n`
                element.show_text += that.jointHtml('今天', 'today', val, unit)
              }
              label.push(element)
            } else if (element.name === 'sys_progress') {
              element.value = await that.getTemplateByFiled(element.fields)
              progress.push(element)
            } else if (element.name === 'sys_chart') {
              var chart_params = element.chart_params
              if (!chart_params) {
                chart_params = {}
              }
              element.value = await that.getTemplateChartByFiled(element.fields, chart_params.type, chart_params.range, chart_params.ration, chart_params.byte_rule, chart_params.unit_name, chart_params.time_range, chart_params.scale)
              charts.push(element)
            }
          }
        }
        that.templateLabel = label
        that.templateProgress = progress
        that.templateChart = charts
        if (label.length === 0 && progress.length === 0 && charts.length === 0) {
          that.templateIsNotNull = false
        } else {
          that.templateIsNotNull = true
        }
        that.templateLoading = true
        if (charts.length > 0) {
          that.echartLoad = true
        }
      }
    },
    async getTemplateByFiled(name, sub_name) {
      var that = this
      var duration = 0
      if (sub_name === 'yesterday') {
        duration = 1
      }
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'get_tsdb_total', role: 1, duration: duration,
        item: `{ "tags": "${name}" }` })
      // console.log('getTemplateByFiled', res)
      if (!res.success) {
        console.log('获取数据失败', res)
        return 0
      }
      var data = res.data
      // console.log(data)

      if (data && data.items && data.items[name] && data.items[name].sum_value) {
        return data.items[name].sum_value
      } else {
        return 0
      }
    },
    async getTemplateChartByFiled(name, type, range, ration, byte_rule, unit_name, time_range, scale) {
      var that = this
      var methodName = 'get_tsdb'
      var duration = 3
      if (type === 'days') {
        duration = 0
        methodName = 'get_tsdb_days'
      }
      if (!range) {
        range = 1
      }
      if (!ration) {
        ration = 1
      }
      if (byte_rule) {
        if (unit_name) {
          ration = that.byteRation(unit_name)
        }
      }
      if (!scale) {
        scale = 0
      }
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId,
        method: methodName, role: 1, duration: duration, time_range: time_range ? JSON.stringify(time_range) : '',
        item: `{ "format": "values", "range": ${range}, "ration": ${ration}, "scale": ${scale}, "tags": "${name}" }` })
      if (!res.success) {
        console.log('获取数据失败', res)
        return null
      }
      var data = res.data
      // console.log(data)
      return data
    },
    strToJson(str) {
      if (!str) {
        return null
      }
      try {
        return JSON.parse(str)
      } catch (error) {
        return null
      }
    },
    rangeArray(v) {
      if (!v) {
        return []
      }
      var strArr = v.split('/')
      return strArr
    },
    byteRation(unit_name) {
      if (!unit_name) {
        return 1
      }
      var ration = 1
      var unit = unit_name.toUpperCase()
      var byteArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var size = 1
      var k = 1024
      for (let i = 0; i < byteArr.length; i++) {
        const item = byteArr[i]
        if (i !== 0) {
          size *= k
        }

        if (unit === item) {
          ration = size
          break
        }
      }
      return ration
    },
    byteFormat(unit_name, val) {
      if (!unit_name || !val) {
        return 0
      }
      var formatVal = 0
      var unit = unit_name.toUpperCase()
      var byteArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var size = 1
      var k = 1024
      for (let i = 0; i < byteArr.length; i++) {
        const item = byteArr[i]
        if (i !== 0) {
          size *= k
        }

        if (unit === item) {
          formatVal = (val / size).toFixed(2)
          break
        }
      }
      return formatVal
    },
    // 内存/cpu使用率百分比颜色分配
    percentColor(val) {
      var color = 'light-blue'
      if (val >= 50) {
        color = 'light-blue'
      }
      if (val >= 70) {
        color = 'orange'
      }
      if (val >= 90) {
        color = 'red lighten-1'
      }
      return color
    },
    jointHtml(date_type, sub_name, val, unit) {
      var that = this
      var strHtml = ''
      if (date_type) {
        strHtml = `<div style="display: inline-block;"><span style="margin-right: 20px;">
                      ${date_type}
                      <span style="font-size: ${sub_name === 'today' ? '28px' : '22px'}; color: #5470c6;">${that.$util.thousandSeparator(val)}</span>
                      <span v-if="${unit}"> ${unit}</span>
                    </span></div>`
      }
      return strHtml
    }

  }
}
</script>

<style scoped>
</style>
